import { jsx as n, css as Ct } from "@emotion/react";
import { Icon as ft } from "@paypalcorp/pp-react-icons";
import { j as z, C as St, F as Tt, T as D, Q as ht, S as Nt, G as M, o as vt, n as bt } from "./helpers-458d7e27.js";
import y from "clsx";
import { Fragment as O, createElement as B, useState as U, useRef as Pt, useMemo as k, useEffect as _, useContext as yt } from "react";
import { jsx as kt } from "react/jsx-runtime";
import { s as q } from "./index-39c86506.js";
import { p as E, a as F, C as W, S as xt, g as wt } from "./SegmentControlGroupContent-ca571e5a.js";
import Ht from "./FaqType.js";
import It from "./ActionBanner.js";
import Lt from "./CardCarousel.js";
import _t from "./CardContentSectionType.js";
import Ot from "./CardWrappedContentSection.js";
import Et from "./FeatureColumnType.js";
import Ft from "./FeatureNavigationSection.js";
import $t from "./LogoStripSection.js";
import Gt from "./LogoTickerSection.js";
import Vt from "./LogoType.js";
import At from "./OfferCardType.js";
import Rt from "./PricingCardHorizontalType.js";
import j from "./PricingMegaCard.js";
import zt from "./PricingCardTableRebrand.js";
import { P as Dt, u as Mt, a as Bt } from "./ProductScrollSection-6842acd1.js";
import Ut from "./ProductValueSection.js";
import Wt from "./SplitSectionType.js";
import jt from "./StackSectionType.js";
import qt from "./TableRebrand.js";
import Kt from "./TextSectionType.js";
import { u as Qt } from "./useSubNavHeight-9afc367c.js";
import "@paypalcorp/pp-react-theme";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
import "./TextHeaderInner-7887aa3a.js";
import "./CardContentSectionItem-9f25a705.js";
import "./FeatureColumnItem-4bc31ce0.js";
import "./TruncatedTextGroup-9d089bba.js";
import "./JumpLinkNavGradient-43d260a5.js";
import "./NavButton-bf29eafc.js";
import "./DocumentBody-0ce19478.js";
import "./ActionCard-9fe808de.js";
import "./SplitSectionItem-5efb0099.js";
import "./MinimalMediaFrame-f9ac5d89.js";
import "./MinimalImageFrame-6a4f63a6.js";
import "./MinimalTextGroup-0c5b3b52.js";
const Xt = {
  actionbanner: It,
  cardcarousel: Lt,
  cardwrappedcontentsection: Ot,
  faqtype: Ht,
  featurecolumntype: Et,
  featurenavigation: Ft,
  logostripsection: $t,
  logotickersection: Gt,
  logotype: Vt,
  offercardtype: At,
  pricingcardhorizontaltype: Rt,
  pricingcardtablerebrand: zt,
  pricingmegacard: j,
  pricingmegacardrebrand: j,
  productscrolltype: Dt,
  relatedcontenttype: _t,
  splitsectiontype: Wt,
  stacksectiontype: jt,
  tablerebrand: qt,
  textsectiontype: Kt,
  productvaluesection: Ut,
  /**
   * ONLY USED FOR TESTING IN STORYBOOK
   */
  children: O
}, Jt = Xt, Yt = {
  options: {
    columnStart: z.leftOuter,
    columnEnd: z.rightOuter
  }
}, Zt = (t, e) => ({
  topSpacing: t,
  bottomSpacing: e,
  rowsGap: "none"
}), te = (t) => t.trim().slice(1), ee = /[\u0300-\u036f]/g, K = (t) => t.normalize("NFD").replace(ee, ""), oe = (t) => (e) => t.map((o) => E(o)).indexOf(te(e).toLowerCase()) > -1, re = (t) => (e) => {
  const o = F(e);
  q.scrollTo(
    o.replace(W.TAB, W.PANEL),
    {
      duration: 0,
      delay: 0,
      smooth: !0,
      offset: -t
    }
  );
}, ae = (t) => {
  switch (t) {
    case "High Contrast":
      return "highContrast";
    case "Low Contrast":
    default:
      return "lowContrast";
  }
}, se = ({ contentTypeId: t, componentReference: e }, o = !0) => {
  const c = t.toLowerCase(), s = Jt[c];
  return s ? c === "productscrolltype" ? /* @__PURE__ */ B(
    s,
    {
      ...e,
      key: `prod-scroll-active-${o}`,
      motion: "none"
    }
  ) : c === "productvaluesection" ? /* @__PURE__ */ B(
    s,
    {
      ...e,
      key: `prod-value-section-active-${o}`
    }
  ) : /* @__PURE__ */ kt(s, { ...e }) : null;
}, ne = (t) => () => q.scrollTo(t, {
  duration: 300,
  delay: 0,
  smooth: !0
}), ie = {
  options: {
    verticalSpacing: "0vw"
  },
  lgOptions: {
    verticalSpacing: "2vw"
  }
}, ce = (t, e) => {
  const [o, c] = U(t[0]), [s, g] = U(0), { pageSegCtrlHeightRef: l, componentPinnedStatus: p } = Mt(), f = Pt(!1), {
    current: { pinned: T }
  } = l, { pinned: u } = Qt(), S = T + u, h = k(
    () => re(S),
    [S]
  ), x = (r) => {
    c(r), g((i) => i + 1);
  }, C = k(
    () => t.map((r) => K(r)),
    [t]
  ), N = k(
    () => oe(C),
    [C]
  );
  return _(() => {
    if (!!window.location.hash) {
      const i = window.location.hash;
      if (N(i)) {
        const v = C.findIndex((H) => E(H) === i.slice(1)), w = t[v] || t[0];
        c(w), f.current = !0;
      }
    }
  }, [C, t, N]), _(() => {
    s === 0 && !f.current || h(o);
  }, [o, s, S, h]), _(() => {
    const r = document.querySelector(
      ".page-segment-control-nav.section-wrapper"
    ), i = r == null ? void 0 : r.firstElementChild, d = document.querySelector("body");
    e && (p.startsWith("pinned") ? (r == null || r.classList.add("sticky"), i == null || i.classList.add("sticky")) : (r == null || r.classList.remove("sticky"), i == null || i.classList.remove("sticky")), u > 0 && (p === "pinned" ? d == null || d.classList.add("stacked-content") : d == null || d.classList.remove("stacked-content")));
  }, [p, u, e]), {
    currTabText: o,
    pageSegCtrlHeightRef: l,
    stickyPositionTop: u,
    tabClickHandler: x
  };
};
const Q = "PageSegmentControlNav", m = new St(Q), le = (t) => `{"link":"PageSegmentControlNav-Link-${bt(
  t
)}","event_name":"smb_text_link_cta_clicked"}`, me = ({
  tabText: t,
  tab1: e,
  tab2: o,
  tab3: c,
  tab4: s,
  tab5: g,
  collection1: l,
  collection2: p,
  collection3: f,
  collection4: T,
  collection5: u
}) => {
  switch (t) {
    case o:
      return p;
    case c:
      return f || [];
    case s:
      return T || [];
    case g:
      return u || [];
    case e:
    default:
      return l;
  }
}, pe = ({
  tabText: t,
  collection: e,
  activeTab: o,
  children: c
}) => {
  const s = o === t, g = y(m.getElementClassName("tab-content"), {
    [m.getElementClassName("active-content")]: s
  });
  return /* @__PURE__ */ n(
    "div",
    {
      role: "tabpanel",
      "aria-labelledby": F(t),
      id: wt(t),
      className: g
    },
    e.map((l, p) => /* @__PURE__ */ n(O, { key: `${t}-${l.contentTypeId}-${p + 1}` }, l.contentTypeId === "children" ? c : se(l, s)))
  );
}, de = ({
  className: t = "",
  tab1: e = "",
  tab2: o = "",
  tab3: c = "",
  tab4: s = "",
  tab5: g = "",
  collection1: l,
  collection2: p,
  collection3: f,
  collection4: T,
  collection5: u,
  anchorLinkText1: S = "",
  anchorLinkUrl1: h = "",
  anchorLinkIcon1: x,
  anchorLinkText2: C = "",
  anchorLinkUrl2: N = "",
  anchorLinkIcon2: r,
  topSpacer: i = "2vw",
  bottomSpacer: d = "2vw",
  sticky: v = !0,
  tabAlignment: w = "Center",
  contrastVariant: H = "Low Contrast",
  theme: I = "white",
  // ** ONLY FOR TESTING PURPOSES **
  children: X
}) => {
  const { foundationTheme: L, foundationColor: $ } = yt(Tt), J = y(
    m.getComponentClassName(),
    t,
    m.getPropsValueClassName("align", w),
    "section-wrapper-transparent"
  ), Y = y(
    D.getThemeClassName(I),
    m.getPropsValueClassName("sticky-wrapper", v),
    L,
    $
  ), Z = y(
    $,
    L,
    D.getThemeClassName(I)
  ), b = k(
    () => [e, o, c, s, g].filter((a) => !!a).map((a) => a.trim()),
    [e, o, c, s, g]
  ), [
    tt = "",
    et = "",
    ot = "",
    rt = "",
    at = ""
  ] = b, {
    currTabText: G,
    stickyPositionTop: st,
    pageSegCtrlHeightRef: nt,
    tabClickHandler: it
  } = ce(b, v), [ct] = ht(["Below XL"]), lt = {
    analyticsEventName: "smb_text_link_cta_clicked",
    selTabItemText: G,
    tabItems: b.map((a) => ({
      href: `#${E(K(a))}`,
      text: a,
      onClick: () => it(a)
    }))
  }, V = (a, R, P) => {
    const gt = ct ? "Caption" : "Body", ut = P == null ? void 0 : P.toLowerCase();
    return /* @__PURE__ */ n(
      "a",
      {
        className: m.getElementClassName("link"),
        href: `#${R}`,
        role: "tab",
        onClick: ne(R),
        id: F(a),
        "data-pa-click": le(a)
      },
      P && /* @__PURE__ */ n(
        ft,
        {
          name: ut,
          className: m.getElementClassName("link-icon"),
          color: "sysColorLinkAlt"
        }
      ),
      /* @__PURE__ */ n(vt, { as: "span", size: gt }, /* @__PURE__ */ n("strong", null, a))
    );
  }, A = S && h, mt = C && N, pt = () => {
    const {
      current: { pinned: a }
    } = nt;
    return a;
  }, dt = ae(H);
  return /* @__PURE__ */ n(Bt, null, /* @__PURE__ */ n("div", { className: m.getElementClassName("wrapper") }, /* @__PURE__ */ n(
    "div",
    {
      className: Y,
      css: Ct`
            top: ${st}px;
            height: ${pt()}px;
          `
    },
    /* @__PURE__ */ n(
      Nt,
      {
        className: J,
        theme: I,
        options: Zt(
          i,
          d
        )
      },
      /* @__PURE__ */ n(
        M,
        {
          ...Yt,
          className: m.getElementClassName("griditem")
        },
        /* @__PURE__ */ n(
          xt,
          {
            ...lt,
            isLarge: L !== "ppe",
            variant: dt
          }
        ),
        A && /* @__PURE__ */ n(
          "div",
          {
            className: m.getElementClassName("links"),
            role: "tablist"
          },
          A && V(
            S,
            h,
            x
          ),
          mt && V(
            C,
            N,
            r
          )
        )
      )
    )
  ), /* @__PURE__ */ n(
    M,
    {
      as: "div",
      ...ie,
      className: Z
    }
  ), b.map((a) => /* @__PURE__ */ n(O, { key: a }, pe({
    children: X,
    tabText: a,
    activeTab: G,
    collection: me({
      tab1: tt,
      tab2: et,
      tab3: ot,
      tab4: rt,
      tab5: at,
      collection1: l,
      collection2: p,
      collection3: f,
      collection4: T,
      collection5: u,
      tabText: a
    })
  })))));
};
de.displayName = Q;
export {
  de as default
};
//# sourceMappingURL=PageSegmentControl.js.map
